module.exports = __webpack_public_path__ + "img/icon_briefcase.74d639a7.svg";